import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import React from 'react';
import flatten from 'lodash/flatten';
import { spreadsheet as coreSpreadsheet } from '@industriousapps/excelkits-core';
import useLoaderEditingAttrs from '../internal/useLoaderEditingAttrs';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const {
  cellReferencesToDimensions
} = coreSpreadsheet;
const defaultSelections = [['A1', 'B1', 'C1']];

const OverviewLoading = _ref => {
  let {
    widgetId,
    sectionId,
    selections = defaultSelections,
    editing = false
  } = _ref;
  const editingAttrs = useLoaderEditingAttrs(editing);
  return /*#__PURE__*/_jsx("ul", {
    className: styles.list,
    children: flatten(selections).map((selection, index) => {
      const {
        width,
        height
      } = cellReferencesToDimensions(selection);
      const size = Math.max(width, height);
      return /*#__PURE__*/_jsxs("li", _objectSpread(_objectSpread({
        className: styles.item
      }, editingAttrs), {}, {
        children: [size >= 2 && /*#__PURE__*/_jsx("span", {
          className: clsx(styles.label, styles['label--loading'])
        }), /*#__PURE__*/_jsx("header", {
          className: styles.item__header,
          children: /*#__PURE__*/_jsx("h6", {
            className: clsx(styles.heading, styles['heading--loading'])
          })
        }), size >= 3 && /*#__PURE__*/_jsx("small", {
          className: clsx(styles.caption, styles['caption--loading'])
        })]
      }), `${widgetId}${sectionId}overview-loader${selection}${index}`);
    })
  });
};

export default OverviewLoading;